/**
 * Detects if the current device has touch capabilities
 * @returns {boolean} True if the device supports touch, false otherwise
 */
export const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};

/**
 * Adds or removes a class to elements based on touch capability
 * @param {string} selector - CSS selector for target elements
 * @param {string} className - Class to add/remove
 */
export const applyTouchClass = (selector, className = "touch-device") => {
  const elements = document.querySelectorAll(selector);

  if (isTouchDevice()) {
    elements.forEach((el) => el.classList.add(className));
  } else {
    elements.forEach((el) => el.classList.remove(className));
  }
};

let currentIsMobile = false;
let currentIsDesktop = true;
let resizeListeners = [];

if (typeof window !== "undefined") {
  currentIsMobile = window.innerWidth < 768;
  currentIsDesktop = window.innerWidth >= 768;
  resizeListeners = [];
}

// Add resize listener to update values
if (typeof window !== "undefined") {
  window.addEventListener("resize", () => {
    const wasMobile = currentIsMobile;
    const wasDesktop = currentIsDesktop;

    currentIsMobile = window.innerWidth < 768;
    currentIsDesktop = window.innerWidth >= 768;

    // Only trigger if state changed
    if (wasMobile !== currentIsMobile || wasDesktop !== currentIsDesktop) {
      resizeListeners.forEach((callback) => callback());
    }
  });
}

export const isMobile = (callback) => {
  if (callback) {
    resizeListeners.push(callback);
  }
  return currentIsMobile;
};

export const isDesktop = (callback) => {
  if (callback) {
    resizeListeners.push(callback);
  }
  return currentIsDesktop;
};

// Optional: Cleanup function to remove listeners
export const removeResizeListener = (callback) => {
  resizeListeners = resizeListeners.filter((cb) => cb !== callback);
};
